import React, { useState } from 'react'
import { createPortal } from 'react-dom'

import { HOME_ROUTES } from "@constants"
import PageWrapper from "Pages/@PageWrapper"
import SearchAnalyticsFilters from "Pages/Main/Page/Filters"
import SearchAnalyticsContent from "Pages/Main/Page/Content"
import VirtualTourButton, { TourOverlay, TOUR_STEPS } from "Pages/Main/Page/VirtualTour"


export default function SearchAnalyticsPage() {
	const [tourActive, setTourActive] = useState(false)

	return <PageWrapper
		head={`DS Rentacar | ${HOME_ROUTES.SEARCH_ANALYTICS_TITLE}`}
		title={HOME_ROUTES.SUBTITLE}
		subtitle={HOME_ROUTES.SEARCH_ANALYTICS_TITLE}
		filters={<SearchAnalyticsFilters/>}
		actions={<VirtualTourButton onClick={() => setTourActive(true)} />}
	>
		<SearchAnalyticsContent/>
		{tourActive && createPortal(
			<TourOverlay steps={TOUR_STEPS} onClose={() => setTourActive(false)} />,
			document.body
		)}
	</PageWrapper>
}
